import { render, staticRenderFns } from "./BadgeLevelPicker.vue?vue&type=template&id=2a0950f7&scoped=true"
import script from "./BadgeLevelPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeLevelPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BadgeLevelPicker.vue?vue&type=style&index=0&id=2a0950f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0950f7",
  null
  
)

export default component.exports